import Score from "./KrScore.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrScore = install(Score); // 生成带有 install 方法的组件

export default KrScore;
